import { useSiteSetupActions } from "@inrange/building-manager-api-client";
import { useState } from "react";
import { Alert, Badge, Button, Spinner } from "react-bootstrap";

const TablesStatusSection = ({
  fetchReadingsTables,
  createReadingsTables,
}: {
  fetchReadingsTables: ReturnType<
    typeof useSiteSetupActions
  >["fetchReadingsTables"];
  createReadingsTables: ReturnType<
    typeof useSiteSetupActions
  >["createReadingsTables"];
}) => {
  const [tablesResult, setTablesResult] = useState<{
    type: "success" | "error";
    message: string;
  } | null>(null);

  const handleCreateTables = async () => {
    setTablesResult(null);
    try {
      const response = await createReadingsTables.mutateAsync();
      setTablesResult({
        type: "success",
        message: `Tables created: ${response.tables_created.join(", ")}`,
      });
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      setTablesResult({ type: "error", message: errorMessage });
    }
  };

  const tablesData = fetchReadingsTables.data;

  return (
    <div>
      <h6 className="fw-bold mb-2">Readings tables</h6>
      {fetchReadingsTables.isLoading ? (
        <Spinner animation="border" size="sm" />
      ) : fetchReadingsTables.isError ? (
        <Alert variant="danger" className="mb-0">
          Failed to fetch readings table status.
        </Alert>
      ) : tablesData?.exists ? (
        <div>
          <Badge bg="success" className="me-2">
            Tables exist
          </Badge>
          <span className="text-muted">
            Raw: {tablesData.raw.row_count} rows, History:{" "}
            {tablesData.history.row_count} rows, Processed:{" "}
            {tablesData.processed.row_count} rows
          </span>
        </div>
      ) : (
        <div className="d-flex align-items-center gap-2">
          <Badge bg="warning" text="dark">
            Tables missing
          </Badge>
          <Button
            variant="primary"
            size="sm"
            onClick={handleCreateTables}
            disabled={createReadingsTables.isLoading}
          >
            {createReadingsTables.isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Creating...
              </>
            ) : (
              "Create readings tables"
            )}
          </Button>
        </div>
      )}
      {tablesResult && (
        <Alert
          variant={tablesResult.type === "success" ? "success" : "danger"}
          dismissible
          onClose={() => setTablesResult(null)}
          className="mt-2 mb-0"
        >
          {tablesResult.message}
        </Alert>
      )}
    </div>
  );
};

export default TablesStatusSection;
